import {useState} from 'react';
import '../assets/css/videocontrols.css';

interface IProps {
    playing: boolean,
    playVideo: () => void,
    muted: boolean,
    setMuted: (mute: boolean) => void,
    videoEl: any,
    duration: number,
    currentVideoTime: number,
    showControls?: boolean
}

export const VideoControls = (props: IProps) => {
    const {
        playing,
        playVideo,
        setMuted,
        muted,
        videoEl,
        duration,
        currentVideoTime,
        showControls

    } = props;
    const [volumeHover, setVolumeHover] = useState<number>(0);
    const [currentVolume, setCurrentVolume] = useState<number>(10);
    const [hoverTime, setHoverTime] = useState<any>(0);
    const [fullScreen, setFullScreen] = useState<boolean>(false);

    const volumeEnter = (volume: number) => {
        setVolumeHover(volume)
    }
    const volumeLeave = () => {
        setVolumeHover(0);
    }
    const setVolume = (vol: number) => {
        const video: any = videoEl.current;
        if (!video) return;
        const volume = vol > 0 ? vol / 10 : 0.0;
        setCurrentVolume(vol);
        video.volume = volume;
    }
    const setCurrentTime = (time: any) => {
        const video: any = videoEl.current;
        if (!video) return;
        video.currentTime = time;
    }
    const secondsToHms = (d: number) => {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor((d % 3600) % 60);

        let hDisplay = h > 0 ? h + ":" : '';
        let mDisplay: string = m + ":";
        let sDisplay: number | string = s;
        if (hDisplay == '' && m <= 0) {
            mDisplay = '';
        }
        if (m < 10) {
            mDisplay = '0' + mDisplay
        }
        if (s < 10) {
            sDisplay = '0' + sDisplay
        }
        if (m == 0) {
            mDisplay = '00:';
        }

        return hDisplay + mDisplay + sDisplay;
    }
    const calcClickedTime = (e: any) => {
        const clickPositionInPage = e.pageX;
        const bar: any = document.querySelector(".tc-player-progress-path");
        if (bar && duration) {
            const barStart = bar.getBoundingClientRect().left + window.scrollX;
            const barWidth = bar.offsetWidth;
            const clickPositionInBar = clickPositionInPage - barStart;
            const timePerPixel = duration / barWidth;
            return timePerPixel * clickPositionInBar;
        }
    }
    const handleTimeDrag = (e: any) => {
        setCurrentTime(calcClickedTime(e));
        const updateTimeOnMove = (eMove: any) => {
            setCurrentTime(calcClickedTime(eMove));
        };

        document.addEventListener("mousemove", updateTimeOnMove);

        document.addEventListener("mouseup", () => {
            document.removeEventListener("mousemove", updateTimeOnMove);
        });
    }
    const toggleFullScreen = () => {
        const elem: any = (document as any).getElementById('main-wrapper');
        if (!elem) return;
        if (fullScreen === true) {
            if ((document as any).exitFullscreen) {
                (document as any).exitFullscreen();
            } else if ((document as any).webkitExitFullscreen) { /* Safari */
                (document as any).webkitExitFullscreen();
            } else if ((document as any).msExitFullscreen) { /* IE11 */
                (document as any).msExitFullscreen();
            }
        } else {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            }
        }
        setFullScreen(!fullScreen);

    };


    return (
        <div className={`tc-player-control-wrapper ${showControls ? 'show-player-controls' : ''}`}>
            <div className="tc-player-control-container">
                {(showControls === true) &&
                    <div className="tc-player-control-left">
                        <div className="tc-player-play-btn-wrapper">
                            <a href="#" onClick={playVideo}
                               className={`tc-control-btn tc-play-btn ${(playing) ? 'playing' : ''} `}>
                                <svg className="tc-play-svg-btn" width="35px" height="35px" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M7.5 4.59863L18.6021 12L7.5 19.4014V4.59863ZM9 7.40141V16.5986L15.8979 12L9 7.40141Z"
                                          fill="#b3b3b3"/>
                                </svg>
                                <svg className="tc-pause-svg-btn" width="35px" height="35px" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 5V19M16 5V19" stroke="#b3b3b3" strokeWidth="2" strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                </svg>
                            </a>
                        </div>
                        <div
                            className={`tc-player-volume-btn-wrapper ${muted ? 'tc-player-volume-mute' : (currentVolume <= 5 ? 'tc-player-volume-low' : 'tc-player-volume-full')}`}>
                            <a href="#" className="tc-control-btn tc-player-vol-btn" onClick={() => setMuted(!muted)}>
                                <svg className="tc-volume-mute-btn" width="35px" height="35px" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M16 9.50009L21 14.5001M21 9.50009L16 14.5001M4.6 9.00009H5.5012C6.05213 9.00009 6.32759 9.00009 6.58285 8.93141C6.80903 8.87056 7.02275 8.77046 7.21429 8.63566C7.43047 8.48353 7.60681 8.27191 7.95951 7.84868L10.5854 4.69758C11.0211 4.17476 11.2389 3.91335 11.4292 3.88614C11.594 3.86258 11.7597 3.92258 11.8712 4.04617C12 4.18889 12 4.52917 12 5.20973V18.7904C12 19.471 12 19.8113 11.8712 19.954C11.7597 20.0776 11.594 20.1376 11.4292 20.114C11.239 20.0868 11.0211 19.8254 10.5854 19.3026L7.95951 16.1515C7.60681 15.7283 7.43047 15.5166 7.21429 15.3645C7.02275 15.2297 6.80903 15.1296 6.58285 15.0688C6.32759 15.0001 6.05213 15.0001 5.5012 15.0001H4.6C4.03995 15.0001 3.75992 15.0001 3.54601 14.8911C3.35785 14.7952 3.20487 14.6422 3.10899 14.4541C3 14.2402 3 13.9601 3 13.4001V10.6001C3 10.04 3 9.76001 3.10899 9.54609C3.20487 9.35793 3.35785 9.20495 3.54601 9.10908C3.75992 9.00009 4.03995 9.00009 4.6 9.00009Z"
                                            stroke="#000000" strokeWidth="1.6" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>

                                <svg className="tc-volume-low-btn" width="35px" height="35px" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M18 9.00009C18.6277 9.83575 18.9996 10.8745 18.9996 12.0001C18.9996 13.1257 18.6277 14.1644 18 15.0001M6.6 9.00009H7.5012C8.05213 9.00009 8.32759 9.00009 8.58285 8.93141C8.80903 8.87056 9.02275 8.77046 9.21429 8.63566C9.43047 8.48353 9.60681 8.27191 9.95951 7.84868L12.5854 4.69758C13.0211 4.17476 13.2389 3.91335 13.4292 3.88614C13.594 3.86258 13.7597 3.92258 13.8712 4.04617C14 4.18889 14 4.52917 14 5.20973V18.7904C14 19.471 14 19.8113 13.8712 19.954C13.7597 20.0776 13.594 20.1376 13.4292 20.114C13.239 20.0868 13.0211 19.8254 12.5854 19.3026L9.95951 16.1515C9.60681 15.7283 9.43047 15.5166 9.21429 15.3645C9.02275 15.2297 8.80903 15.1296 8.58285 15.0688C8.32759 15.0001 8.05213 15.0001 7.5012 15.0001H6.6C6.03995 15.0001 5.75992 15.0001 5.54601 14.8911C5.35785 14.7952 5.20487 14.6422 5.10899 14.4541C5 14.2402 5 13.9601 5 13.4001V10.6001C5 10.04 5 9.76001 5.10899 9.54609C5.20487 9.35793 5.35785 9.20495 5.54601 9.10908C5.75992 9.00009 6.03995 9.00009 6.6 9.00009Z"
                                            stroke="#000000" strokeWidth="1.6" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>

                                <svg className="tc-volume-full-btn" width="35px" height="35px" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M16.0004 9.00009C16.6281 9.83575 17 10.8745 17 12.0001C17 13.1257 16.6281 14.1644 16.0004 15.0001M18 5.29177C19.8412 6.93973 21 9.33459 21 12.0001C21 14.6656 19.8412 17.0604 18 18.7084M4.6 9.00009H5.5012C6.05213 9.00009 6.32759 9.00009 6.58285 8.93141C6.80903 8.87056 7.02275 8.77046 7.21429 8.63566C7.43047 8.48353 7.60681 8.27191 7.95951 7.84868L10.5854 4.69758C11.0211 4.17476 11.2389 3.91335 11.4292 3.88614C11.594 3.86258 11.7597 3.92258 11.8712 4.04617C12 4.18889 12 4.52917 12 5.20973V18.7904C12 19.471 12 19.8113 11.8712 19.954C11.7597 20.0776 11.594 20.1376 11.4292 20.114C11.239 20.0868 11.0211 19.8254 10.5854 19.3026L7.95951 16.1515C7.60681 15.7283 7.43047 15.5166 7.21429 15.3645C7.02275 15.2297 6.80903 15.1296 6.58285 15.0688C6.32759 15.0001 6.05213 15.0001 5.5012 15.0001H4.6C4.03995 15.0001 3.75992 15.0001 3.54601 14.8911C3.35785 14.7952 3.20487 14.6422 3.10899 14.4541C3 14.2402 3 13.9601 3 13.4001V10.6001C3 10.04 3 9.76001 3.10899 9.54609C3.20487 9.35793 3.35785 9.20495 3.54601 9.10908C3.75992 9.00009 4.03995 9.00009 4.6 9.00009Z"
                                            stroke="#000000" strokeWidth="1.6" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>
                            </a>

                            <div className="tc-player-volume-control" onMouseLeave={volumeLeave}>
                                <span
                                    className={`${muted === false && (volumeHover >= 1 || (volumeHover == 0 && currentVolume >= 1)) ? 'active' : ''} ${volumeHover == 1 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(1)} onClick={() => setVolume(1)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 2 || (volumeHover == 0 && currentVolume >= 2)) ? 'active' : ''} ${volumeHover == 2 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(2)} onClick={() => setVolume(2)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 3 || (volumeHover == 0 && currentVolume >= 3)) ? 'active' : ''} ${volumeHover == 3 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(3)} onClick={() => setVolume(3)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 4 || (volumeHover == 0 && currentVolume >= 4)) ? 'active' : ''} ${volumeHover == 4 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(4)} onClick={() => setVolume(4)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 5 || (volumeHover == 0 && currentVolume >= 5)) ? 'active' : ''} ${volumeHover == 5 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(5)} onClick={() => setVolume(5)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 6 || (volumeHover == 0 && currentVolume >= 6)) ? 'active' : ''} ${volumeHover == 6 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(6)} onClick={() => setVolume(6)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 7 || (volumeHover == 0 && currentVolume >= 7)) ? 'active' : ''} ${volumeHover == 7 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(7)} onClick={() => setVolume(7)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 8 || (volumeHover == 0 && currentVolume >= 8)) ? 'active' : ''} ${volumeHover == 8 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(8)} onClick={() => setVolume(8)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 9 || (volumeHover == 0 && currentVolume >= 9)) ? 'active' : ''} ${volumeHover == 9 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(9)} onClick={() => setVolume(9)}></span>
                                <span
                                    className={`${muted === false && (volumeHover >= 10 || (volumeHover == 0 && currentVolume >= 10)) ? 'active' : ''} ${volumeHover == 10 ? 'last' : ''}`}
                                    onMouseEnter={() => volumeEnter(10)} onClick={() => setVolume(10)}></span>
                                <div
                                    className="cur-volume">{muted ? '0' : (volumeHover > 0 ? volumeHover : currentVolume)}</div>
                            </div>
                        </div>
                        <div className="tc-player-duration-wrapper">
                            <span className="tc-player-progress-time">{secondsToHms(currentVideoTime)}</span>
                            <span className="tc-player-divider">/</span>
                            {duration && <span className="tc-player-duration">{secondsToHms(duration)}</span>}
                        </div>
                    </div>}

                <div className="tc-player-progressbar-wrapper">
                    <div className="tc-player-progress-path" onMouseDown={e => handleTimeDrag(e)}>
                        <div className="tc-player-progressing-path"
                             style={{width: (currentVideoTime / duration) * 100 + '%'}}></div>
                        {/* <div className="tc-player-hover-progressing-path" style={{width: hoverTime + '%'}}></div> */}

                    </div>
                </div>

                {/* <div className="tc-player-control-right">
                    <div className="tc-player-logo">
                        <img
                            src="https://demoassets.touchcast.com/profile-assets/tc_showtime_logo.png"
                            alt=""/>
                    </div>
                    <div className="tc-player-fullscreen">
                        <a href="#" className="tc-control-btn tc-player-vol-btn" onClick={toggleFullScreen}>
                            <svg className="tc-player-fullscreen-btn" width="30px" height="30px" viewBox="0 0 24 24"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="style=linear">
                                    <g id="fullscreen">
                                        <path id="vector" d="M8 2H4C2.89543 2 2 2.89543 2 4V8" stroke="#000000"
                                              strokeWidth="2" strokeLinecap="round"/>
                                        <path id="vector_2" d="M22 8L22 4C22 2.89543 21.1046 2 20 2H16" stroke="#000000"
                                              strokeWidth="2" strokeLinecap="round"/>
                                        <path id="vector_3" d="M16 22L20 22C21.1046 22 22 21.1046 22 20L22 16"
                                              stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
                                        <path id="vector_4" d="M8 22L4 22C2.89543 22 2 21.1046 2 20V16" stroke="#000000"
                                              strokeWidth="2" strokeLinecap="round"/>
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </div>
                </div> */}
            </div>
        </div>
    )
}
